module.exports = __webpack_public_path__ + "img/495.f4d2799d.jpg";